<template>
	<div class="container-fluid bg-white">
		<contact-toolbar>
			<button class="btn btn-success" v-on:click="newLocation">
				<i class="fa fa-plus"></i>
				New Location
			</button>
		</contact-toolbar>
		<div class="row" style="min-height: 300px;">
			<div class="col-lg-8">
				
				<table-list
					record-name="Location"
					:fields="fields"
					:records="mutatedLocations"
					:has-edit="true"
					:has-delete="true"
					delete-endpoint="ContactLocation/delete"
					id-field="slug"
					v-on:edit="editLocation"
					v-on:delete="fetchLocations">

					<h2>{{$store.contact.name}} Locations</h2>

				</table-list>
			</div>
			<div class="col-lg-4 map-panel">
				<vue-map class="map-frame"
					:zoom="mapStart.zoom"
					:center="mapStart.center"
					:markers="contactLocationMarkers"
					v-on:markerClick="markerClick">
				</vue-map>
			</div>
		</div>


		<contact-location-edit-modal
			:visible="locationModal.visible"
			:contact-id="$store.contact.id"
			:record="locationModal.payload"
			v-on:locationSaved="locationSaved"
			v-on:locationDeleted="fetchLocations"
			v-on:closeModal="locationModal.visible = false">
		</contact-location-edit-modal>


	</div>
</template>

<script>
import ContactToolbar from "./ContactToolbar"
import ContactMixins from "@/mixins/ContactMixins"
import TableList from "@/components/TableList"
import Field from "@/components/Field"
import ModalDialog from "@/components/ModalDialog"
import VueMap from "@/components/VueMap"

import AddressManualSelector from "@/components/AddressManualSelector"
import ContactLocationEditModal from "@/components/super_components/ContactLocationEditModal"

export default {

	name: 'ContactLocations',
	components: {
		ContactToolbar,
		TableList,
		Field,
		ModalDialog,
		AddressManualSelector,
		VueMap,
		ContactLocationEditModal
	},
	mixins:[
		ContactMixins
	],
	data() {
		return {
			fields: [
				{label: "Location Name",key:'location_name'},
				{label: "Address", key:'address'},
				{label: "City", key:'city'},
				{label: "Province", key:'province'},
				{label: "Country", key:'country'},
				{label: "Postal Code", key:'postal_code'},
				{label: "Coordinates", key:'coords'},
				{label: "Email", key:'email'},
				{label: "Phone #", key:'phone'},
			],
			locationModal: {
				visible: false,
				title: "Add New Location",
				payload: {}
			},
			selectedMarkerId: null,
			showMap:false
		}
	},
	watch: {
		'$store.contact'() {
			if (this.$store.contact && "ContactLocation" in this.$store.contact)
				this.fetchLocations()
		}
	},
	computed: {
		mapStart() {
			let center, zoom = 10
			if ('lat' in this.$store.contact && 'long' in this.$store.contact && this.$store.contact.lat && this.$store.contact.long)
				center = {lat:+this.$store.contact.lat,lng:+this.$store.contact.long}
			
			else if ('lat' in this.$store.company && 'long' in this.$store.company && this.$store.company.lat && this.$store.company.long) {
				center = {lat:+this.$store.company.lat,lng:+this.$store.company.long}
				zoom = 9
			}
			else {
				zoom = 6
				center = {lat: 43.5, lng: -79.5}
			}

			return {
				zoom,
				center
			}
		},
		contactLocationMarkers() {
			if (this.$store.contact.ContactLocation) {
				let markers = this.$store.contact.ContactLocation.map(loc => {
					let infoWindowText = ""
					if (loc.location_name)
						infoWindowText = loc.location_name+"\n"

					infoWindowText += loc.address

					return {
						location_id: loc.id,
						lat: +loc.lat,
						lng: +loc.long,
						infoWindowText
					}
				})

				if ('lat' in this.$store.contact && 'long' in this.$store.contact && this.$store.contact.lat && this.$store.contact.long) {
					markers.push({
						location_id: null,
						lat: +this.$store.contact.lat,
						lng: +this.$store.contact.long,
						infoWindowText: 'Main Location'
					})
				}

				return markers
			}
			return []
		},
		mutatedLocations() {
			let vm = this
			if (this.$store.contact.ContactLocation) {
				return this.$store.contact.ContactLocation.map(loc => {
					loc.coords = loc.lat + " " + loc.long

					if (loc.id == vm.selectedMarkerId)
						loc.rowClasses = "bg-light"
					else
						loc.rowClasses = ""

					return loc
				})
			}
			else
				return []
		}
	},
	methods: {
		markerClick(marker) {
			this.selectedMarkerId = marker.location_id
		},
		newLocation() {
			this.locationModal.visible = true
			
			this.locationModal.payload = {
				location_name: "",
				suite: "",
				email: "",
				phone: "",
				address: "",
				city: "",
				province: null,
				country: "",
				postal_code: "",
			}
		},
		editLocation(record) {
			this.locationModal.visible = true
			this.locationModal.payload = record
		},
		locationSaved() {
			this.fetchLocations()
			this.alertSaved("Location saved!")
		},
		fetchLocations() {
			let vm = this

			this.spinner(true)

			this.getJSON("ContactLocation/get",{filters:[["contact_id",this.$store.contact.id]]}).then(response => {
				vm.spinner(false)

				if (response.success) {
					vm.$store.contact.ContactLocation = response.data
				}
			})

		},
		fetchData() {
			let vm = this

			this.spinner(true)

			let promises = [
				this.fetchContact(this.$route.params.id,["ContactLocation",{model:"ContactFile", fields:[]}])
			]

			Promise.all(promises).then(responses => {
				vm.spinner(false)
			})
		}
	},
	created() {
		if (!("ContactLocation" in this.$store.contact))
			this.fetchData()
	}

}
</script>

<style type="text/css" scoped>
	.map-panel {
		padding-right: 0;
	}

	.map-frame {
		height: calc(100% + 10px);
		margin-top: -10px;
	}

	@media (max-width: 1200px) {
		.map-frame {
			margin-top: -15px;
			height: calc(100% + 15px);
		}
	}

	@media (max-width: 992px) {
		.map-panel {
			padding-right: 15px;
		}

		.map-frame {
			height: 400px;
			margin-top: 10px;
		}
	}
</style>